import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { colorUtils, layout } from '@prisjakt/ui-base';
import { PaginationItem } from './pagination-items';

export const Pagination = styled.ul`
  display: flex;
  justify-content: center;
  list-style: none;
  margin: 0;
`;

type PaginationItemProps = {
  indicateOmittedPages: PaginationItem['indicateOmittedPages'];
};

export const PaginationListItem = styled.li<PaginationItemProps>`
  margin-left: ${props =>
    props.indicateOmittedPages === 'before' ? layout.spacing.medium : 0};
  margin-right: ${props =>
    props.indicateOmittedPages === 'after'
      ? layout.spacing.medium
      : layout.spacing.xxSmall};

  &:last-child {
    margin-right: 0;
  }
`;

const paginationItemStyles = css`
  align-items: center;
  border-radius: 8px;
  display: flex;
  font-weight: 600;
  height: 30px;
  justify-content: center;
  min-width: 30px;
  padding: ${layout.spacing.xSmall};
  transition: all ${layout.animations.buttonTransition};
`;

export const PaginationLink = styled(Link)`
  ${paginationItemStyles}
  background: ${props => props.theme.bg.primary};
  box-shadow: ${props => `inset 0 0 0 1px ${props.theme.lines.primary}`};
  color: ${props => props.theme.text.primary};

  &:hover,
  &.focus-visible {
    background: ${props =>
      colorUtils.setRgbaAlpha(props.theme.buttons.primary.bg, '0.2')};
    box-shadow: none;
  }
`;

export const DisabledPaginationLink = styled.span`
  ${paginationItemStyles}
  box-shadow: ${props => `inset 0 0 0 1px ${props.theme.lines.primary}`};
  color: ${props => props.theme.text.quaternary};
  background: ${props => props.theme.bg.secondary};
  cursor: default;
`;

export const CurrentPaginationLink = styled.span`
  ${paginationItemStyles}
  background: ${props => props.theme.buttons.primary.bg};
  color: ${props => props.theme.buttons.primary.text};
  cursor: default;
`;
